import React from "react";
import styled from "styled-components";
import Image from "next/image";
import ClockIcon from "../../../../../public/images/clock_white.svg";
import CocktailBrownIcon from "../../../../../public/images/cocktail_white.svg";
import LocationMaincolorIcon from "../../../../../public/images/location_icon_white.svg";
import CutleryIcon from "../../../../../public/images/cutlery_white.svg";
import GroupIcon from "../../../../../public/images/group_white.svg";
import WorldIcon from "../../../../../public/images/world_white.svg";
import LibraryIcon from "../../../../../public/images/library_white.svg";
import SmileIcon from "../../../../../public/images/smile_white.svg";
import {getColor} from "@/styles/ThemeConfig";
import CustomDropdown from "@/components/other/CustomDropdown";
import ReviewOverlay from "@/components/base/ReviewOverlay";
import {HeroCarousel} from "@/components/other/HeroCarousel";
import {breakpoints} from "@/styles/sizes";
import StarIcon from "../../../../../public/images/star_gold.svg";
import EmbeddedPageSection from "@/components/other/EmbeddedPageSection";
import {VariantBHeroCarousel} from "@/components/other/VariantBHeroCarousel";
import Breadcrumbs from "@/components/other/Breadcrumbs";
import VariantBBreadcrumbs from "@/components/tour/sections/variantB/VariantBBreadcrumbs";
import VariantBLogosSection from "@/components/tour/sections/variantB/VariantBLogosSection";


const Section = styled.section`
    padding-top: 50px;

  position: relative;
  width: 100%;
  color: #fff;
  min-height: 700px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;


const Overlay = styled.div`
    z-index: 2;
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
`;

const Content = styled.div`
  position: relative;
  z-index: 11;
  padding: 48px 24px;
  text-align: center;
`;

const ReviewBar = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  font-size: 14px;
  opacity: 0.95;
`;

const Stars = styled.span`
  color: #F7B600;
  letter-spacing: 2px;
    padding-top: 5px;
`;

const Title = styled.h1`
  margin: 0 0 8px;
  font-size: 51px;
  line-height: 1.1;
  font-weight: 700;
  text-transform: uppercase;
`;

const Description = styled.p`
  max-width: 820px;
  margin: 0 auto 20px;
  font-size: 16px;
  line-height: 1.6;
  opacity: 0.95;
    font-family: 'Poppins';
`;


const CTA = styled.a`
  margin: 12px 0 24px;
  background: #FF5A5F;
  color: #fff;
  border: 0;
  padding: 14px 22px;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
    text-decoration: none;
    background: #FF5A5F;
    box-shadow: 0px 4px 30px #000000;
    border-radius: 7.10448px;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 15.9851px 35.5224px;

    padding-top: 20px;

    width: fit-content;
    height: 67.97px;

    background: #FF5A5F;
    box-shadow: 0px 4px 30px #000000;
    border-radius: 7.10448px;

    flex: none;
    order: 3;
    flex-grow: 0;

    align-self: center;
    justify-self: center;
`;

const Badges = styled.ul`
  list-style: none;
  padding: 0;
  margin: 18px 0 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
  justify-content: center;
  font-size: 14px;
  opacity: 0.95;
`;

const InfoItem = styled.div`
    color: ${getColor('white')};
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
    font-size: 14px;
    font-family: 'Inter';
`;

const VideoWrapper = styled.div`
    height: 650px;
    @media only screen and (${breakpoints.mobile}) {
        height: 250px;
    }
`;



// No display toggle here on purpose: TourPageVariantB renders either this hero
// or VariantBHeroSectionMobile, never both, so exactly one <h1> reaches the DOM.
// Hiding it with CSS as well would blank the hero whenever the User-Agent guess
// and the viewport disagree (e.g. a desktop browser in a narrow window).
const DesktopWrapper = styled.div``;

export default function VariantBHeroSection({
    cityName,
    ctaButtonData,

    reviewOverlayData,
    heroReviewsText,
    heroMedia,
    title,
    dropdownData,
    dropdownBackButtonText,
    dropdownBackButtonLink,
    heroTitle,heroDescription,
    duration, location, numOfStops, numOfPeople, type, funFact,language,wineTastings, images,
                                                breadcrumbs,
    pressLogos,
}) {

    const isHeroVideo = [
        'video/mp4',     // MP4
        'video/webm',    // WebM
        'video/ogg',     // Ogg
        'video/quicktime', // MOV
        'video/x-msvideo', // AVI
        'video/x-ms-wmv',  // WMV
        'video/x-flv',   // FLV
        'video/mpeg',    // MPEG
        'video/3gpp',    // 3GPP
        'video/3gpp2',   // 3GPP2
        'video/x-matroska', // MKV
        'video/vnd.dlna.mpeg-tts', // DLNA MPEG-TS
        'application/vnd.apple.mpegurl', // HLS (M3U8)
        'video/x-m4v'    // M4V
    ].includes(heroMedia?.[0]?.mime);

    if(isHeroVideo){
        if(images?.[0]){
            heroMedia = images
        }
    }


  return (
      <DesktopWrapper>
          <Section>
              <div className={'desktop_only'}>
                  <CustomDropdown
                      items={dropdownData}
                      backButtonText={dropdownBackButtonText}
                      backButtonLink={dropdownBackButtonLink}
                      customRed={'#FF5A5F'}
                  />
              </div>

              <Overlay />

              {
                  isHeroVideo && (
                      <VideoWrapper>
                          <video
                              key={heroMedia?.[0]?.url}
                              ref={(videoElement) => {
                                  if (videoElement) {
                                      setTimeout(() => {
                                          videoElement.play().catch((err) => {
                                              console.error("Video play failed", err);
                                          });
                                      }, 500); // Delay autoplay by 500ms
                                  }
                              }}
                              loop
                              muted
                              playsInline
                              preload="metadata"
                              controls={true}
                              poster={'/images/video_default_poster.jpg'}
                              style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  zIndex: 1, // Ensure the video is in the background
                              }}
                          >
                              <source src={heroMedia?.[0]?.url} type={heroMedia?.[0]?.mime}/>
                              Your browser does not support the video tag.
                          </video>
                      </VideoWrapper>
                  )
              }

              {!isHeroVideo && <VariantBHeroCarousel
                  images={heroMedia}
                  style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      zIndex: 1, // Ensure the video is in the background
                  }}
              />}


              <Content>
                  <ReviewBar>
                      <Stars>
                          <Image src={StarIcon} alt={'StarIcon'}/>
                          <Image src={StarIcon} alt={'StarIcon'}/>
                          <Image src={StarIcon} alt={'StarIcon'}/>
                          <Image src={StarIcon} alt={'StarIcon'}/>
                          <Image src={StarIcon} alt={'StarIcon'}/>
                      </Stars>
                      <span style={{fontFamily:'Playfair Display'}}>
            {heroReviewsText ?? reviewOverlayData?.data?.leftText}
          </span>
                  </ReviewBar>

                  <Title>{heroTitle ?? title }</Title>


                  <Description>{heroDescription ?? `Skip the tourist traps and truly discover ${cityName} with our top-rated guided food tour, which takes you to delicious, lesser-known food spots loved by locals`}</Description>

                  {ctaButtonData?.item_link &&
                        <div
                            style={{
                                display:'flex',
                                justifyContent:'center',
                                alignItems:'center',
                            }}
                        >
                          <CTA href={ctaButtonData?.item_link ?? '#'}>{ctaButtonData?.item_title ?? 'Book your Tour'}</CTA>
                        </div>
                  }

                  <Badges>
                      {
                          duration && <InfoItem>
                              <Image src={ClockIcon} alt="ClockIcon" width={20} height={20} /> {duration}
                          </InfoItem>
                      }
                      {
                          wineTastings && <InfoItem>
                              <Image src={CocktailBrownIcon} alt="CocktailBrownIcon" width={20} height={20} /> {wineTastings}
                          </InfoItem>

                      }
                      {
                          location &&   <InfoItem>
                              <Image src={LocationMaincolorIcon} alt="LocationMaincolorIcon" width={20} height={20} /> {location}
                          </InfoItem>
                      }
                      {
                          !!parseInt(numOfStops) &&  <InfoItem>
                              <Image src={CutleryIcon} alt="CutleryIcon" width={20} height={20} /> {numOfStops}
                          </InfoItem>
                      }
                      {
                          !!parseInt(numOfPeople) && <InfoItem>
                              <Image src={GroupIcon} alt="GroupIcon" width={20} height={20} /> {numOfPeople}
                          </InfoItem>
                      }
                      {
                          language && <InfoItem>
                              <Image src={WorldIcon} alt="WorldIcon" width={20} height={20} /> {language}
                          </InfoItem>
                      }
                      {/*{*/}
                      {/*    type &&  <InfoItem>*/}
                      {/*        <Image src={LibraryIcon} alt="LibraryIcon" width={20} height={20} /> {type}*/}
                      {/*    </InfoItem>*/}
                      {/*}*/}
                      {/*{*/}
                      {/*    funFact && <InfoItem>*/}
                      {/*        <Image src={SmileIcon} alt="SmileIcon" width={20} height={20} /> {funFact}*/}
                      {/*    </InfoItem>*/}
                      {/*}*/}
                  </Badges>

                  <Image
                      priority
                      loading={'eager'}
                      src={reviewOverlayData?.leftImageDesktop?.url}
                      alt={reviewOverlayData?.leftImageDesktop?.alt ?? reviewOverlayData?.leftImageDesktop?.name}
                      width="430"
                      height="46"
                      style={{
                          width: '430px',
                          maxWidth: '100%',
                          height: 'auto',
                      }}
                  />
              </Content>
          </Section>
          <div style={{marginBottom:'50px'}}>
              <VariantBLogosSection logos={pressLogos} borderBottom/>
          </div>

          <Container
              className={'container_small'}
          >
              <h2 className={'h1'} style={{
                  fontFamily: "system-ui",
                  fontWeight: 400,
                  marginTop: '30px',
                  marginBottom: '20px',
              }}>{title}</h2>

              <VariantBBreadcrumbs items={breadcrumbs}/>
          </Container>
      </DesktopWrapper>
  );
}


const Container = styled.div`
    margin-top:20px;
    margin-bottom:50px;
`;


